// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/images/inside_banner.jpg");
var ___CSS_LOADER_URL_IMPORT_1___ = require("../../assets/images/inside_banner_float.png");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banner-wrapper[data-v-00e90d47]{width:1920px;height:400px;background:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") no-repeat center center;background-size:100% auto}.banner-wrapper .float[data-v-00e90d47]{position:absolute;width:1920px;height:456px;background:url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ") no-repeat center center;background-size:100% auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
